import { getLang } from '@/helpers/getLang'
import { setJwtToken } from '@/helpers/setRequestHeaders'
import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'

export type Tag = {
    id: number
    title: string
    value: string
}

type TagDto = {
    title: string
    value: string
}

export const tagsApi = createApi({
    reducerPath: 'tagsApi',
    baseQuery: fetchBaseQuery({
        baseUrl: process.env.NEXT_PUBLIC_API_ENDPOINT || 'http://megakorm.ru:3005/api',
        prepareHeaders: setJwtToken
    }),
    tagTypes: ["TAG"],
    endpoints: builder => ({
        getTag: builder.query<Tag, { id: number }>({
            query: id => ({ url: `/tag/${id}` }),
            providesTags: ["TAG"]
        }),
        getAllTags: builder.query<Tag[], void>({
            query: () => ({ url: '/tag' }),
            providesTags: ["TAG"]
        }),
        getAllTagsEn: builder.query<Tag[], void>({
            query: () => ({ url: '/tag?lang=en' }),
            providesTags: ["TAG"]
        }),
        getNewsFilterTags: builder.query<Tag[], void>({
            query: () => ({ url: `/articles/articles/tags?lang=${getLang()}` }),
            providesTags: ["TAG"]
        }),
        getMaterialsFilterTags: builder.query<Tag[], void>({
            query: () => ({ url: `/articles/useful-materials/tags?lang=${getLang()}` })
        }),
        createTag: builder.mutation<any, TagDto>({
            query: (data) => ({ url: `/tag`, method: "POST", body: data }),
            invalidatesTags: ["TAG"]
        }),
        deleteTagsByIds: builder.mutation<any, any>({
            query: (data) => ({ url: `/tag/delete-by-ids`, method: "POST", body: data }),
            invalidatesTags: ["TAG"]
        }),
        updateTag: builder.mutation<Tag, {item: TagDto, id: number}>({
            query: (data)=>({url: `/tag/${data.id}`, method: "PATCH", body: data.item}),
            invalidatesTags: ["TAG"]
        }),
        updateTagEn: builder.mutation<Tag, {item: TagDto, id: number}>({
            query: (data)=>({url: `/tag/en/update/${data.id}`, method: "PATCH", body: data.item}),
            invalidatesTags: ["TAG"]
        }),
    })
})

export const { useUpdateTagEnMutation, useGetTagQuery, useGetAllTagsEnQuery, useGetAllTagsQuery, useGetNewsFilterTagsQuery, useGetMaterialsFilterTagsQuery, useCreateTagMutation, useDeleteTagsByIdsMutation, useUpdateTagMutation } = tagsApi
